import { createTheme } from '@mui/material';

const colors = {
  background: {
    100: 'hsl(0, 0%, 99%)',
    200: 'hsl(220, 35%, 97%)',
  },
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#DFFFEA',
    },
    secondary: {
      main: '#1db954',
    },
    background: {
      default: colors.background[200],
      paper: colors.background[100],
    },
  },
  typography: {
    allVariants: {
      color: 'rgb(0, 0, 0)',
    },
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 700,
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgb(244, 253, 247)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '&.reseller-search': {
            '& .MuiOutlinedInput-root': {
              fieldset: {
                border: 'none',
              },
              '&:hover fieldset': {
                border: 'none',
              },
            },
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& label.Mui-focused': {
            color: '#000000de',
          },
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              border: '1px solid #0000003b',
            },
          },
        },
      },
    },
  },
});

export default theme;
